import { Route, Routes } from 'react-router-dom'
import { UserSettings } from './view/user-settings'
import { CompanySettings } from './view/company-settings'
import { BillingAndInvoice } from './view/billing-invoice'
import MyCompanies from './view/MyCompanies'

const SettingsRoutes = () => {
  // const {formatMessage} = useIntl()

  return (
    <div className='mt-3'>
      <Routes>
        <Route
          path='/user-settings'
          element={
            <>
              <UserSettings />
            </>
          }
        />

        <Route
          path='company-settings'
          element={
            <>
              <CompanySettings />
            </>
          }
        />
        <Route
          path='my-companies'
          element={
            <>
              <MyCompanies />
            </>
          }
        />
        <Route
          path='billing-invoice'
          element={
            <>
              <BillingAndInvoice />
            </>
          }
        />
      </Routes>
    </div>
  )
}

export default SettingsRoutes
